import {
    defaultBaseQuery,
    transformRequest,
    transformErrorResponse,
    transformSuccessResponse
} from '@/services';
import { createApi } from '@reduxjs/toolkit/query/react';

// TODO: Endpoints are an assumed contract — align with the backend once the College Project API is ready
const collegeprojectapi = createApi({
    baseQuery: defaultBaseQuery,
    reducerPath: 'collegeprojectapi',
    endpoints: (builder) => ({
        getCollegeProjects: builder.query({
            query: () => ({
                url: `/student/projects`,
                method: 'GET'
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        addCollegeProject: builder.mutation({
            query: (data) => ({
                url: `/student/projects`,
                method: 'POST',
                body: transformRequest(data)
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        updateCollegeProject: builder.mutation({
            query: ({ id, ...data }) => ({
                url: `/student/projects/${id}`,
                method: 'PUT',
                body: transformRequest(data)
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        deleteCollegeProject: builder.mutation({
            query: (projectId) => ({
                url: `/student/projects/${projectId}`,
                method: 'DELETE'
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse
        }),
    }),
});

export const {
    useLazyGetCollegeProjectsQuery,
    useAddCollegeProjectMutation,
    useUpdateCollegeProjectMutation,
    useDeleteCollegeProjectMutation
} = collegeprojectapi;

export default collegeprojectapi;
